<template>
  <b-img
    class="logo"
    :src="logoSrc"
  />
</template>
<script>
import logo from '@/views/logics/components/logo'

export default {
  mixins: [logo],
}
</script>

<style scoped>
.logo {
  width: 150px;
}
</style>
